import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Messaggi di validazione dei moduli in italiano (sostituiscono quelli nativi del browser)
const validityMsg = (el) => {
  const v = el.validity;
  if (v.valueMissing) return el.type === "checkbox" ? "Seleziona questa casella per continuare." : "Compila questo campo.";
  if (v.typeMismatch && el.type === "email") return "Inserisci un indirizzo email valido.";
  if (v.tooShort) return `Inserisci almeno ${el.minLength} caratteri.`;
  if (v.patternMismatch || v.typeMismatch || v.badInput) return "Il valore inserito non è valido.";
  if (v.rangeUnderflow || v.rangeOverflow) return "Il valore inserito è fuori dall'intervallo consentito.";
  return "";
};
document.addEventListener("invalid", (e) => e.target.setCustomValidity?.(validityMsg(e.target)), true);
document.addEventListener("input", (e) => e.target.setCustomValidity?.(""), true);
document.addEventListener("change", (e) => e.target.setCustomValidity?.(""), true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
